import { call, put, takeLatest } from 'redux-saga/effects';
import { modulesApi } from '../../api/modules-api';
import {
  fetchPermissionsStart,
  fetchPermissionsSuccess,
  fetchPermissionsFailure,
} from '../permissions-slice';

// Saga para obtener permisos agrupados por recurso
function* fetchPermissionsSaga(): Generator<any, void, any> {
  try {
    yield put(fetchPermissionsStart());
    const response: any = yield call(
      modulesApi.permissions.getPermissionsGroupedByResource
    );
    // Asegurar que la respuesta sea un array
    const permissions = Array.isArray(response) 
      ? response 
      : Array.isArray(response?.data) 
        ? response.data 
        : [];
    yield put(fetchPermissionsSuccess(permissions));
  } catch (error: any) {
    yield put(
      fetchPermissionsFailure(
        error.message || 'Error al obtener los permisos'
      )
    );
  }
}

// Watcher saga
export function* watchFetchPermissions() {
  yield takeLatest('rbacPermissions/fetchPermissions', fetchPermissionsSaga);
}

// Root saga para permisos RBAC
export function* rbacPermissionsSaga() {
  yield takeLatest('rbacPermissions/fetchPermissions', fetchPermissionsSaga);
}

